export function formatPermissionGroupToForm(permissionGroup: any) {
  return {
    ...permissionGroup,
    permissions:
      permissionGroup.permissions.flatMap((permission: any) => [
        permission.id,
      ]) || [],
  };
}
